import { ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useClient, useClientPackages, useCreateClientPackage } from '../../api';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';
import { wnSendTrace } from '../../utils/wn-event-utils';
import { DocumentTable } from './DocumentTable';

export const DocumentTableContainer: FunctionComponent = () => {
    const { t } = useTranslation();
    const { navigate } = useWealthPlanningNavigate();

    const { data: client } = useClient();
    const { draftPackage } = useClientPackages();
    const createClientPackage = useCreateClientPackage();

    const onCreateClientPackage = async () => {
        const clientPackage = await createClientPackage.mutateAsync(client!.id);
        navigate(`/${client!.partnerUuid}/documents/${clientPackage.id}`);
        wnSendTrace({
            feature: 'client-package',
            tags: {
                partnerUuid: client!.partnerUuid,
                action: 'create-new-client-package',
                source: 'create-package-button',
                newPackageId: `${clientPackage.id}`,
            },
        });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' }}>
            <div className="document-screen__title" style={{ flexShrink: 0 }}>
                <h4>{t('clientPackageListTitle')}</h4>
                <ZfTextButton disabled={draftPackage != null} size="small" onClick={onCreateClientPackage}>
                    {t('clientPackageCreate')}
                </ZfTextButton>
            </div>
            <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                <DocumentTable />
            </div>
        </div>
    );
};
